import { t } from "i18next";

import { Genre } from "../personal-informations/personal-informations";

import {
  AestethicNutritionTypes,
  DefinitionNutritionTypes,
  HypertrophyNutritionTypes,
} from "./aestethic-nutrition-types";
import { BodyCompositions } from "./body-compositions";
import { Cuisines } from "./cuisines";
import { HealthNutritionTypes } from "./health-nutrition-types";
import { NutritionGoals } from "./nutrition-goals";
import { TrainingDurations } from "./training-durations";
import { WorkEffortLevels } from "./work-effort-levels";
import { RadioButtonGroupOption } from "@/shared/components/atoms/RadioButtonGroup";
import { NutritionObjectives } from "./nutrition-objectives";
import { Option } from "@/shared/utils/options";

export const objectiveOptions: Array<RadioButtonGroupOption> = [
  {
    key: NutritionObjectives.Health,
    text: "Entrenamiento saludable compensatorio",
    description: "Mejora la salud física y el bienestar",
    value: NutritionObjectives.Health,
  },
  {
    key: NutritionObjectives.Hypertrophy,
    text: "Incremento de masa muscular",
    description: "(Hipertrofia)",
    value: NutritionObjectives.Hypertrophy,
  },
  {
    key: NutritionObjectives.Definition,
    text: "Reducción del tejido graso",
    description: "(Definición, tonificación)",
    value: NutritionObjectives.Definition,
  },
];

export const cuisineOptions: Array<RadioButtonGroupOption> = [
  {
    value: Cuisines.Mediterranean,
    text: t("contexts.nutrition.cuisine_mediterranean"),
    description: t("contexts.nutrition.cuisine_mediterranean_description"),
  },
  {
    value: Cuisines.International,
    text: t("contexts.nutrition.cuisine_international"),
    description: t("contexts.nutrition.cuisine_international_description"),
  },
];

export const aestethicNutritionTypeOptions: Array<RadioButtonGroupOption> = [
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_standart"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_standart_description"
    ),
    value: AestethicNutritionTypes.Standart,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_sporty"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_sporty_description"
    ),
    value: AestethicNutritionTypes.Sports,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_vegetarian"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_vegetarian_description"
    ),
    value: AestethicNutritionTypes.Vegetarian,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy_description"
    ),
    value: AestethicNutritionTypes.GlutenAndDairyFree,
  },
  {
    key: 5,
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_description"
    ),
    value: AestethicNutritionTypes.GlutenFree,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_no_dairy"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_dairy_description"
    ),
    value: AestethicNutritionTypes.DairyFree,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    description: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    value: AestethicNutritionTypes.LowInCarbohydrates,
  },
];

export const hypertrophyNutritionTypeOptions: Array<RadioButtonGroupOption> = [
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_standart"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_standart_description"
    ),
    value: HypertrophyNutritionTypes.Standart,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_sporty"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_sporty_description"
    ),
    value: HypertrophyNutritionTypes.Sports,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_vegetarian"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_vegetarian_description"
    ),
    value: HypertrophyNutritionTypes.Vegetarian,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy_description"
    ),
    value: HypertrophyNutritionTypes.GlutenAndDairyFree,
  },
  {
    key: 5,
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_description"
    ),
    value: HypertrophyNutritionTypes.GlutenFree,
  },

  {
    text: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    description: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    value: HypertrophyNutritionTypes.LowInCarbohydrates,
  },
];

export const definitionNutritionTypeOptions: Array<RadioButtonGroupOption> = [
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_standart"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_standart_description"
    ),
    value: DefinitionNutritionTypes.Standart,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_sporty"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_sporty_description"
    ),
    value: DefinitionNutritionTypes.Sports,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_vegetarian"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_vegetarian_description"
    ),
    value: DefinitionNutritionTypes.Vegetarian,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_no_dairy_description"
    ),
    value: DefinitionNutritionTypes.GlutenAndDairyFree,
  },
  {
    key: 5,
    text: t("contexts.nutrition.aestethic_nutrition_type_no_gluten"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_gluten_description"
    ),
    value: DefinitionNutritionTypes.GlutenFree,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_no_dairy"),
    description: t(
      "contexts.nutrition.aestethic_nutrition_type_no_dairy_description"
    ),
    value: DefinitionNutritionTypes.DairyFree,
  },
  {
    text: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    description: t("contexts.nutrition.aestethic_nutrition_type_low_carb"),
    value: DefinitionNutritionTypes.LowInCarbohydrates,
  },
];

export const healthNutritionTypeOptions = [
  {
    value: HealthNutritionTypes.Standart,
    text: t("contexts.nutrition.health_nutrition_type_standart"),
    description: t(
      "contexts.nutrition.health_nutrition_type_standart_description"
    ),
  },
  {
    value: HealthNutritionTypes.Vegetarian,
    text: t("contexts.nutrition.health_nutrition_type_vegetarian"),
    description: t(
      "contexts.nutrition.health_nutrition_type_vegetarian_description"
    ),
  },
  {
    value: HealthNutritionTypes.Vegan,
    text: t("contexts.nutrition.health_nutrition_type_vegan"),
    description: t(
      "contexts.nutrition.health_nutrition_type_vegen_description"
    ),
  },
  {
    value: HealthNutritionTypes.DairyFree,
    text: t("contexts.nutrition.health_nutrition_type_no_dairy"),
    description: t(
      "contexts.nutrition.health_nutrition_type_no_dairy_description"
    ),
  },
  {
    value: HealthNutritionTypes.GlutenFree,
    text: t("contexts.nutrition.health_nutrition_type_no_gluten"),
    description: t(
      "contexts.nutrition.health_nutrition_type_no_gluten_description"
    ),
  },
  {
    value: HealthNutritionTypes.FishFree,
    text: t("contexts.nutrition.health_nutrition_type_no_fish"),
    description: t(
      "contexts.nutrition.health_nutrition_type_no_fish_description"
    ),
  },
];

export const bodyCompositionOptions: Array<RadioButtonGroupOption> = [
  {
    value: BodyCompositions.Obesity,
    text: t("contexts.nutrition.body_composition_obesity"),
  },
  {
    value: BodyCompositions.Overweight,
    text: t("contexts.nutrition.body_composition_overweight"),
  },
  {
    value: BodyCompositions.Normal,
    text: t("contexts.nutrition.body_composition_my_weight"),
  },
  {
    value: BodyCompositions.Muscular,
    text: t("contexts.nutrition.body_composition_muscled"),
  },
];

export const workEffortOptions: Array<RadioButtonGroupOption> = [
  {
    value: WorkEffortLevels.None,
    text: t("contexts.nutrition.work_effort_level_ultra_light"),
    description: t("contexts.nutrition.work_effort_level_ultra_light"),
  },
  {
    value: WorkEffortLevels.Light,
    text: t("contexts.nutrition.work_effort_level_light"),
    description: t("contexts.nutrition.work_effort_level_light_description"),
  },
  {
    value: WorkEffortLevels.Intermediate,
    text: t("contexts.nutrition.work_effort_level_medium"),
    description: t("contexts.nutrition.work_effort_level_medium_description"),
  },
  {
    value: WorkEffortLevels.High,
    text: t("contexts.nutrition.work_effort_level_high"),
    description: t("contexts.nutrition.work_effort_level_high_description"),
  },
];

export const trainingDurationOptions: Array<RadioButtonGroupOption> = [
  {
    value: TrainingDurations.OneHourNormal,
    text: t("contexts.nutrition.training_duration_one_hour_normal"),
    description: t(
      "contexts.nutrition.training_duration_one_hour_normal_description"
    ),
  },
  {
    value: TrainingDurations.OneDotFiveHourHard,
    text: t("contexts.nutrition.training_duration_one_dot_five_hours_hard"),
    description: t(
      "contexts.nutrition.training_duration_one_dot_five_hours_hard_description"
    ),
  },
  {
    value: TrainingDurations.TwoHourIntense,
    text: t("contexts.nutrition.training_duration_two_hours_hard"),
    description: t(
      "contexts.nutrition.training_duration_two_hours_hard_description"
    ),
  },
  {
    value: TrainingDurations.TwoOrMoreHour,
    text: t("contexts.nutrition.training_duration_two_or_more_hours"),
    description: t(
      "contexts.nutrition.training_duration_two_or_more_hours_description"
    ),
  },
];

export const healthNutritionGoalOptions: Array<RadioButtonGroupOption> = [
  {
    value: NutritionGoals.WeightLoss,
    text: t("contexts.nutrition.nutritional_objective_fat_loss"),
  },
  {
    value: NutritionGoals.OptimalSpent,
    text: t("contexts.nutrition.nutritional_objective_maintenance"),
  },
];

export const aestethicNutritionGoalOptions: Array<RadioButtonGroupOption> = [
  {
    value: NutritionGoals.Hypertrophy,
    text: t("contexts.nutrition.nutritional_objective_hypertrophy"),
  },
  {
    value: NutritionGoals.Definition,
    text: t("contexts.nutrition.nutritional_objective_definition"),
  },
];


export type CalculateKcalArgs = {
  genre: Genre;
  age: number;
  weight: number;
  height: number;
  workEffortLevel: WorkEffortLevels;
  trainingDuration: TrainingDurations;
  nutritionGoal: NutritionGoals;
  bodyComposition: BodyCompositions;
};

export function calculateBasalMetabolicRate(
  genre: Genre,
  age: number,
  weight: number,
  height: number
): number {
  const genreValue = genre == Genre.Female ? -161 : 5;
  return 10 * weight + 6.25 * height - 5 * age + genreValue;
}

export function calculateKcal(args: CalculateKcalArgs) {
  const basalMetabolicRate = calculateBasalMetabolicRate(
    args.genre,
    args.age,
    args.weight,
    args.height
  );

  const kcal =
    basalMetabolicRate +
    args.workEffortLevel * basalMetabolicRate +
    args.trainingDuration * basalMetabolicRate +
    args.nutritionGoal * basalMetabolicRate +
    args.bodyComposition * basalMetabolicRate;

  return kcal;
}
